import '@site/styles/sass/styles.scss';

import $ from 'jquery';
import 'jquery-migrate';
import 'jquery-validation';
import 'slick-carousel';
import 'magnific-popup';
import './vendor/niceSelect.js';
import { createCookie, readCookie, addClass, removeClass, toggleClass, hasClass, siblings, scrollTop, setText } from './plugins.js';
import './modules/accordion';
import './modules/form';

window.$ = window.jQuery = $;

$(document).ready(function() {
	if ($('.popup-youtube').length) {
		$('.popup-youtube').magnificPopup({
			disableOn: 100,
			type: 'iframe',
			// items: {
			// 	src: '<iframe src="https://www.youtube-nocookie.com/embed/bfr82RB72U8?autoplay=1&rel=0" frameborder="0" allowfullscreen></iframe>',
			// 	// type: 'inline'
			// },
			mainClass: 'mfp-fade',
			removalDelay: 160,
			preloader: false,
			fixedContentPos: false
		});
	}
});

function sleep(ms) {
	return new Promise(resolve => setTimeout(resolve, ms));
}

async function awaitFunc() {
	await sleep(1000);
	// popup.click();
}

var _window;
$(document).ready(function(){
	_window = $(window);
	awaitFunc();
	window.odometerOptions = {
		duration: 5000
	};

	// ---
	// Nav
	// ---
	// Navigate when nav select is changed (for mobile)
	$('.nav-select').on('change', 'select', function(){
		if (this.value !== '')
			window.location = this.value;
	});

	// Use a collapseable mobile nav
	// Currently non-animated version
	$('.js-nav-mobile')
		.on('click', function(){
			var elBody = document.querySelector('body');

			toggleClass(elBody, 'nav__open');

			$('.site-wrap').toggleClass('menuopen');
		});

	$('.nav-main > ul > li')
		.each(function(index, el) {
			$(this).children('a').on('focus', function(e) {
				e.preventDefault();

				var $parent = $(this).parent();
				if ($parent.children('ul').length > 0) {
					$parent.addClass('open');
				}
			});

			$(this).children('a').on('blur', function(e) {
				e.preventDefault();

				var $parent = $(this).parent();
				setTimeout(function() {
					if ($parent.hasClass('open') && $parent.find('a:focus').length == 0) {
						$parent.removeClass('open');
					}
				}, 1);
			});

			$(this).children('ul').find('a').on('blur', function(e) {
				e.preventDefault();

				var $parent = $(this).closest('ul').parent();
				setTimeout(function() {
					if ($parent.hasClass('open') && $parent.find('a:focus').length == 0) {
						$parent.removeClass('open');
					}
				}, 1);
			});
		});

	// add side white background for "Crime Info" menu
	$('.menu-wrapper').first().addClass('side-white-bg');

	// -----------
	// Nice Select
	// -----------
	$('.nice-select-selector').niceSelect();
	$('.form-formz select').niceSelect();


	// -----------------
	// Email Obfuscation
	// -----------------
	$('.js-email-hidden')
		.each(function(index, element){
			setText(element, element.getAttribute('data-user') + '@' + element.getAttribute('data-domain'));

			element.href = 'mailto:' + element.getAttribute('data-user') + '@' + element.getAttribute('data-domain');
		});


	// --------------
	// External Links
	// --------------
	$('[rel=external]').attr('target', '_blank');


	// --------------
	// Image Captions
	// --------------
	$('img[title]').each(function(index, elImg){
		var _image = $(elImg),
			__figure = $('<figure />'),
			__figcaption = $('<figcaption />');

		var f = elImg.style.cssFloat || elImg.style.styleFloat || false;

		if (f === 'left') {
			__figure.addClass('fig-left');
		} else if (f === 'right') {
			__figure.addClass('fig-right');
		}

		_image
			.addClass('fig-img')
			.after(__figure);

		__figcaption
			.text(_image.attr('title'));

		__figure
			.append(_image)
			.append(__figcaption);

		__figure
			.css({
				paddingBottom: __figcaption.outerHeight()
			});

		_image = null;
		__figure = null;
		__figcaption = null;
	});


	// --------------
	// Slick Carousel
	// --------------
	// $('.js-slick-carousel').slick({
	// 	dots: true,
	// 	infinite: false,
	// 	speed: 300,
	// 	slidesToShow: 4,
	// 	slidesToScroll: 4,
	// 	responsive: [{
	// 		breakpoint: 1024,
	// 		settings: {
	// 			slidesToShow: 3,
	// 			slidesToScroll: 3,
	// 			infinite: true,
	// 			dots: true
	// 		}
	// 	}, {
	// 		breakpoint: 600,
	// 		settings: {
	// 			slidesToShow: 2,
	// 			slidesToScroll: 2
	// 		}
	// 	}, {
	// 		breakpoint: 480,
	// 		settings: {
	// 			slidesToShow: 1,
	// 			slidesToScroll: 1
	// 		}
	// 	}]
	// });

	$('.js-slick-carousel').slick({
		dots: true,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1
	});

    $('.js-slick-home-carousel').slick({
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000
	});

	// ---------------
	// Form Validation
	// ---------------
	// http://jqueryvalidation.org/validate
	$('.js-form-validate').each(function(index, element){
		var _form = $(element);

		_form.validate({
			errorContainer: element.querySelector('.js-error-container'),
			errorLabelContainer: element.querySelector('.js-error-container'),
			wrapper: 'div'
		});

		/*
			rules : {
				"emailconfirm": {
					equalTo: "#email"
				}
			},
			messages: {
				"emailconfirm": {
					equalTo: 'Please confirm your email address'
				}
			},
		*/
	});


	// ---------
	// Scroll In
	// ---------
	(function(){
		var cache = {};
		cache.scrollTop = scrollTop();
		cache.windowHeight = _window.height();

		var _img = $('img'),
			_odo = $('.odometer');

		_img
			.on('test', function(){
				if (hasClass(this, 'inview')) return;

				var rect = this.getBoundingClientRect();

				if (rect.top < cache.windowHeight) {
					removeClass(this, 'outofview');
					addClass(this, 'inview');
				} else {
					addClass(this, 'outofview');
				}
			});

		_odo
			.on('test', function(){
				if (hasClass(this, 'inview')) return;
				if (!this.getAttribute('data-odo')) return;

				var rect = this.getBoundingClientRect();

				if (rect.top < cache.windowHeight) {
					addClass(this, 'inview');
					this.textContent = this.getAttribute('data-odo');
				}
			});

		_window
			.on('scroll', function(){
				cache.scrollTop = scrollTop();
				_img.trigger('test');
				_odo.trigger('test');
			});
	})();

	_window
		.on('load', function(){
			$('.hero')
				.addClass('hero__loaded');

			var elHeroSpans = document.querySelectorAll('.hero_over span');

			var funcShowSpan = function(el, delay) {
				setTimeout(function(){
					addClass(el, 'hero_over__show');
				}, i * 250);
			}

			for (var i = 0, l = elHeroSpans.length; i < l; i++) {
				funcShowSpan(elHeroSpans[i], i * 500);
			}
		});


	// ------
	// Search
	// ------
	$('.js-form-search')
		.each(function(index, elForm){
			$(elForm)
				.on('focus', 'input', function(){
					addClass(elForm, 'form-search__focus');
				})
				.on('blur', 'input', function(){
					removeClass(elForm, 'form-search__focus');
				});
		});

	// for search bar in mobile web page header
	$('.js-nav-search-1').on('click', function(){
		$('.row-container').addClass('search-bar-open');

		$('.js-nav-search-1').removeClass('header-site_mobile_button');
		$('.js-nav-search-1').addClass('hide');

		$('.search-form-1').removeClass('hide');

		$('.site-wrap').addClass('search-bar-open');
	});

	// for search bar in mobile menu
	$('.js-nav-search-2').on('click', function(){
		$('.nav-mobile-header').addClass('search-bar-open');

		$('.js-nav-search-2').removeClass('header-site_mobile_button');
		$('.js-nav-search-2').addClass('hide');

		$('.search-form-2').removeClass('hide');
	});


	// ------
	// mobile menu
	// ------

	// for mega-menu & normal dropdown menu
	// Note: #nav-menubar li:nth-child(5) > a is for "About us" menu item,
	//       #nav-menubar li:nth-child(6) > a is for "Get Involved" menu item
	$('.mega-list-item > a, .sub-menus > a').each(function (index, elForm) {
        $(elForm).on('click', function (e) {
            // console.log($(elForm).next());

            let windowsize = $(window).width();

            $(window).resize(function () {
                windowsize = $(window).width();
            });

            // only disable this hyperlink on mobile
            if (windowsize < 980) {
                e.preventDefault();
            }

            // turn dropdown triangle upside down when open the submenu
            $(elForm).toggleClass('upsidedown');

            // show submenu when click
            $(elForm).next().toggleClass('show');
        });
    });


	// ------------
	// ServicesForm
	// ------------
	$('.js-form-services')
		.each(function(index, elForm){
			var _form = $(elForm);

			var elSearch = document.querySelector('.searches'),
				elSearchResults = document.querySelector('.js-searches-results');

			_form.validate({
				errorContainer: elForm.querySelector('.js-error-container'),
				errorLabelContainer: elForm.querySelector('.js-error-container div'),
				submitHandler: function(elForm){
					$.ajax('/service-search', {
						data: $(elForm).serialize(),
						success: function(data){
							elSearchResults.innerHTML = data;
							if (elSearch) {
								addClass(elSearch, 'show');
							}
						}
					});
				},
				wrapper: 'div'
			});
		});

	$('.js-searches-results')
		.each(function(index, elSearchResults){
			var elSearch = document.querySelector('.searches');

			$(elSearchResults)
				.on('click touchend', '.pagination a', function(event){
					event.preventDefault();
					var data = this.href.substr(this.href.indexOf('?') + 1);
					$.ajax('/service-search', {
						data: data,
						success: function(data){
							elSearchResults.innerHTML = data;
							if (elSearch) {
								addClass(elSearch, 'show');
							}
						}
					});
				});
		});

	$('.js-close-searches')
		.on('click touchend', function(){
			var elSearch = document.querySelector('.searches');
			removeClass(elSearch, 'show');
		});


	// -------
	// Cookies
	// -------
	if (false && readCookie('policy') !== 'accepted') {
	} else {
		createCookie('policy', 'accepted', 365);
	}


	// -------------
	// Media Queries
	// -------------
	(function(){
		var updateTel = function(mq){
			if (mq.matches) {
				$('[data-tel]')
					.each(function(index, el){
						var _el = $(el);
						_el.attr('href', 'tel:'+_el.data('tel'));
					});
			} else {
				$('[data-tel]').removeAttr('href');
			}
		};
		if (window.matchMedia) {
			var mq = window.matchMedia( "(max-width: 767px)" );
			mq.addListener(updateTel);
			updateTel(mq);
		}
	})();

	// --------------------
	// Placeholder Function
	// --------------------
	function placeholderFunc(index, element){
		var ph = element.getAttribute('placeholder'),
			_input = $(this);

		_input.on({
			focus: function(){
				if (element.value == ph) {
					element.value = '';
					removeClass(element, 'placeholder-replacement');
				}
			},
			blur: function(){
				if (element.value == "") {
					element.value = ph;
					addClass(element, 'placeholder-replacement');
				}
			}
		}).blur();

	}


	// -----------
	// Placeholder
	// -----------
	if(!Modernizr.input.placeholder){
		$('[placeholder]').each(placeholderFunc);
	}


	var elBlanket = document.querySelector('.safety-blanket');

	$('.js-leave')
		.on('click', function(){
			addClass(elBlanket, 'show');
		});

	$('.js-filter-type')
		.on('click', function(event){
			event.preventDefault();

			var elInput = document.getElementById('services-type'),
				elSibl = siblings(this);

			elInput.value = this.getAttribute('data-value');
			$(elInput.form).trigger('submit');

			addClass(this, 'base');

			for (var i = 0, l = elSibl.length; i < l; i++) {
				removeClass(elSibl[i], 'base');
			}
		});


	// ----
	// Tabs
	// ----
	$('.js-tabs').each(function(index, el){
		var mq = {},
			tabs = el,
			links = tabs.querySelectorAll('.js-tabs-links a'),
			_links = $(links),
			subsequentClick = false;

		if (window.matchMedia) {
			mq = window.matchMedia( "(max-width: 767px)" );
		} else {
			mq.matches = false;
		}

		_links
			.on('click', function(ev){
				ev.preventDefault();

				var tab = document.querySelector(this.href.substr(this.href.indexOf('#'))),
					sibl = tab.parentNode.children;

				// Show Tab Content
				for (var i = 0; i < sibl.length; i++) {
					if (sibl[i] !== tab)
						addClass(sibl[i], 'hidden');
				}
				removeClass(tab, 'hidden');

				// Highlight Tab Link
				for (var i = 0; i < links.length; i++) {
					if (links[i] !== tab)
						removeClass(links[i].parentNode, 'tab-active');
				}
				addClass(this.parentNode, 'tab-active');

				if (mq.matches && subsequentClick) {
					// scroll to the top of the tabs to highlight //
					var rect = tabs.getBoundingClientRect();
					$('html, body')
						.animate({ scrollTop: rect.top + _ad.window.scrollTop() });
				}

				subsequentClick = true;

				// when side tabs in "Victims Code" subpage are clicked, scroll to top of the page
				$(window).scrollTop(0);
			})
			.first()
			.each(function(index, elLink){
				if (!hasClass(elLink.parentNode, 'no-autoclick')) {
					$(elLink).click();
				}
			});
	});

	$('.js-click-proxy')
		.on('click', function(event){
			event.preventDefault();

			var lnk = this.getAttribute('data-click'),
				elTgt = document.getElementById(lnk);

			$(elTgt).click();
		});


	// ------
	// menu (Victims Code)
	// ------

		let clickedSubMenu = "";
		let tabId = "";

		// $('#nav-menubar li:nth-child(2) .mega-menu .medium-wrap .menu-item a')
		// .each(function(index, elForm){
		// 	$(elForm)
		// 	.on('click', function(e) {
		// 		// e.preventDefault();
		// 		// console.log($(elForm));


		// 		// use RegEx to get element's href value
		// 		clickedSubMenu = /(?<=\/#tab-)\d+/.exec($(elForm).attr("href"))[0];
		// 		// console.log(clickedSubMenu);

		// 		$('.js-tabs-links li a')
		// 		.each(function(index, elForm){
		// 			// console.log($(elForm).attr("id"));
		// 			// console.log('tab id:', /(?<=tab-link-)\d+/.exec($(elForm).attr("id"))[0]);

		// 			// use RegEx to get element's id value
		// 			tabId = /(?<=tab-link-)\d+/.exec($(elForm).attr("id"))[0];

		// 			if(tabId === clickedSubMenu) {
		// 				console.log('true');

		// 				// only apply on the smaller screens
		// 				if ($(window).width() < 980) {
		// 					// close the mobile menu
		// 					$('.nav-main_close').trigger('click');

		// 					// close the "Victims Code" menu drop down
		// 					$('#nav-menubar li:nth-child(2) a').removeClass('upsidedown');
		// 					$('#nav-menubar li:nth-child(2) .mega-menu').removeClass('show');
		// 				}

		// 				$(elForm).click();
		// 			}
		// 		});
		// 	});
		// });

		// Note: this part need to put below Tabs section
		const url = window.location.href.split('/');
		const urlSeg = url[3] + '/' + url[4];
		// console.log('[href='+urlSeg+']');
		// console.log($('[href="'+urlSeg+'"]'));

		$('.js-tabs-links [href="'+urlSeg+'"]').trigger('click');



    // ---------
	// Skipping
    // ---------
    $('.js-screen-reader').each(function(idx, el) {
        $(this).on('click', function(e) {
            e.preventDefault();

			if ($(this).attr('id') === 'tomain') {
				$('.header-site').next().find('a').eq(0).focus();
			} else if ($(this).attr('id') === 'tomenu') {
                if (window.matchMedia('(min-width: 768px)').matches) {
                    $('.nav-main').find('a').eq(0).focus();
                } else {
                    $('.header-site').find('a').eq(0).focus();
                }
            }

            var $parent = $(this).parent();
            setTimeout(function() {
                if ($parent.hasClass('skip-section') && $parent.hasClass('show') && $parent.find('a:focus').length == 0) {
                    $parent.removeClass('show');
                }
            }, 1);
        })

        $(this).on('focus', function(e) {
            e.preventDefault();

            var $parent = $(this).parent();
            if ($parent.hasClass('skip-section')) {
                $parent.addClass('show');
            }
        });

        $(this).on('blur', function(e) {
            e.preventDefault();

            var $parent = $(this).parent();
            setTimeout(function() {
                if ($parent.hasClass('skip-section') && $parent.hasClass('show') && $parent.find('a:focus').length == 0) {
                    $parent.removeClass('show');
                }
            }, 1);
        });
    });

	// ---------------
	// Live Chat Modal
    // ---------------
	$('#openLiveChatModalBtn').on('click', function() {
		const targetModalID = $(this).attr('data-modal-target');
		const targetModalEl = $(`#${targetModalID}`);

		targetModalEl.css('display', 'block');
		setTimeout(() => targetModalEl.addClass('show'), 10);
	});

	$('#liveChatModal .js-modal-close').on('click', function() {
		$('#liveChatModal').removeClass('show');
		setTimeout(() => $('#liveChatModal').css('display', 'none'), 300);
	});

	$(document).on('click', function(e) {
		if (!$(e.target).closest('#liveChatModal, #openLiveChatModalBtn').length) {
		  $('#liveChatModal').removeClass('show');
		  setTimeout(() => $('#liveChatModal').css('display', 'none'), 300);
		}
	});
});